import { Layout, Row, Spin, Table } from "antd";
import axios from "axios";

import React, { Component } from "react";
import { connect } from "react-redux";
import { Constant } from "../../config";

import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import FilterForm from "./form";
import getColumn from "./column";

import services from "./services";

const { Content } = Layout;

class GatewayCountryLogs extends Component {
  state = {
    loading: false,
    dataSource: [],
    countryList: [],
    gatewayList: [],
    adminList: [],
    defaultSearch: null,
  };

  currentPage = 1;
  currentSearch = "";
  limit = 10;
  totalRows = 0;

  componentWillMount() {
    this.props.fetchMenuAction("gateway", "gateway-country-logs");
    this.setState({ loading: true });
  }

  async componentDidMount() {
    const adminList = await services.getAdminLists();
    const adminIds = adminList.adminIds.toString();

    const defaultSearch = { created_by: adminIds, member_id: -1 };
    this.currentSearch = JSON.stringify(defaultSearch);
    const { totalRows, dataSource } = await services.getGatwayCountryLogsLists(
      this.currentPage,
      this.limit,
      this.currentSearch
    );

    this.totalRows = totalRows;

    this.setState({
      loading: false,
      dataSource,
      countryList: await this._getCountryList(),
      gatewayList: await this._getGatewayList(),
      adminList: adminList.list,
      defaultSearch,
    });
  }

  _getCountryList = async () => {
    const opt = {
      url: `${Constant.COUNTRY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    let rtn = [{ region_code: "NONE", name: "Default" }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  };

  _getGatewayList = async () => {
    const opt = {
      url: `${Constant.GATEWAY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data;
  };

  afterFormSubmit = (value) => {
    let tmp;
    if (value) {
      tmp = JSON.parse(value);
      tmp = { ...this.state.defaultSearch, ...tmp };

      if (tmp["created_by"]) {
        tmp["created_by"] = `${tmp["created_by"]}`;
      }
    } else {
      tmp = this.state.defaultSearch;
    }
    //add memberid = 1;

    this.currentSearch = JSON.stringify(tmp);
    this.changePage(this.currentPage, this.limit);
  };

  changePage = async (page, limit) => {
    this.setState({ loading: true });
    this.currentPage = page;
    this.limit = limit;

    const { dataSource, totalRows } = await services.getGatwayCountryLogsLists(
      page,
      limit,
      this.currentSearch
    );

    if (totalRows > 0 && dataSource.length === 0) {
      this.changePage(1, this.limit);
      this.setState({ loading: false });
    }

    this.totalRows = totalRows;
    this.setState({
      dataSource,
      loading: false,
    });
  };

  render() {
    const propsTable = {
      className: "my-table",
      columns: getColumn(this.state.countryList, this.state.gatewayList),
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize: this.limit,
        total: this.totalRows,
        current: this.currentPage,
        onChange: this.changePage,
        size: "small",
      },
    };
    // let propsTableForMobile = Object.assign({}, propsTable)
    // propsTableForMobile.className = "my-table-mobile"
    // propsTableForMobile.columns = this.columnsMobile

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <FilterForm
            adminList={this.state.adminList}
            countryList={this.state.countryList}
            onSubmit={(v) => this.afterFormSubmit(v)}
          />
          <Content
            style={{
              background: "#fff",
              padding: 24,
              margin: "16px 0",
              minHeight: 300,
            }}
          >
            <Row className="utility-bar-mobile"></Row>
            <Table {...propsTable} />
            {/* <Table {...propsTableForMobile} /> */}
          </Content>
        </Spin>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headerBarStore: state.headerBar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GatewayCountryLogs);



// WEBPACK FOOTER //
// ./src/containers/GatewayCountryLogs/index.js